import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=3a0f3ee0&"
import script from "./Pay.vue?vue&type=script&lang=ts&"
export * from "./Pay.vue?vue&type=script&lang=ts&"
import style0 from "./Pay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports